import FormControlLabel from '@mui/material/FormControlLabel';
import Autocomplete from '@mui/material/Autocomplete';
import {forwardRef, useImperativeHandle} from 'react';
import FormControl from '@mui/material/FormControl';
import InputLabel from '@mui/material/InputLabel';
import TextField from '@mui/material/TextField';
import MenuItem from '@mui/material/MenuItem';
import Checkbox from '@mui/material/Checkbox';
import {useTranslation} from "react-i18next";
import Select from '@mui/material/Select';
import Grid from '@mui/material/Grid';
import {observer} from 'mobx-react';
import {TT_SUBSPEC, TT_SPEC, STEP_SPEC, COUNTRY_ID_FI, FIRST_OBS_STEP} from './Util.js';
import {useGlobalStorage} from './mobx/GlobalStorage.js';
import {strToState, stateToStr} from './StateDialog.js';
import {brCodeList, uncertLevelList} from './Lists.js';
import {getShortSpecName} from './Trans.js';

const AddSpec = observer(forwardRef((props, ref) => {
	const gStorage = useGlobalStorage();
	const {t} = useTranslation('obs');

	function specChange(event, value) {
		if (value != null) {
			gStorage.add.setObsSpec(value.id);
			if (!value.fin_breeder) {
				gStorage.add.setFinBrCode(0);
			}

			if (!value.sexing) {
				gStorage.add.setSex(0);
			}

			if (!value.woodpecker) {
				gStorage.add.obs.subobs.forEach((so, ind) => {
					let a = strToState(so.sum_desc).filter((s) => s !== 'rumm');
					gStorage.add.setSOState(ind, stateToStr(a), so.state_valid);
				});
			}
		} else {
			gStorage.add.setObsSpec(0);
			gStorage.add.setFinBrCode(0);
			gStorage.add.setSex(0);

			gStorage.add.obs.subobs.forEach((so, ind) => {
				let a = strToState(so.sum_desc).filter((s) => s !== 'rumm');
				gStorage.add.setSOState(ind, stateToStr(a), so.state_valid);
			});
		}

		gStorage.add.setSpec(value)
	}

	function twitchChange(event, value) {
		gStorage.add.setTwitched(value ? 1 : 0);
	}

	function ecoChange(event, value) {
		gStorage.add.setEco(value ? 1 : 0);
	}

	function memoChange(event) {
		gStorage.add.setMemo(event.target.value);
	}

	function addSpecGetSpecName(tax) {
		return getShortSpecName(tax, gStorage.conn.user);
	}

	function sortTaxons(t1, t2) {
		const n1 = addSpecGetSpecName(t1);
		const n2 = addSpecGetSpecName(t2);

		return n1.localeCompare(n2, 'fi');
	}

	// function sortIndentTaxons(t1, t2) {
	// 	return t1.disp_name.localeCompare(t2.disp_name, 'fi');
	// }

	/* ----------------------------------------------------------------- */

	function finBrCodeList() {
		return brCodeList.map((code, ind) => {
			return (<MenuItem key={code.id} value={code.id}>{code.cat.length ? t(code.name) + ', ' + t(code.short_desc) : t(code.name)}</MenuItem>);
		});
	}

	function finBrCodeChanged(event) {
// 		console.log('finBrCodeChange', br);
		gStorage.add.setFinBrCode(parseInt(event.target.value, 10));
	}

	/* ----------------------------------------------------------------- */

	function uncertaintyList() {
		return uncertLevelList.map((level, ind) => {
			return (<MenuItem key={level.id} value={level.id}>{level.desc.length ? t(level.name) + ', ' + t(level.desc) : t(level.name)}</MenuItem>);
		});
	}

	function uncertaintyChanged(event) {
		gStorage.add.setUncertainty(parseInt(event.target.value, 10));
	}

	/* ----------------------------------------------------------------- */

	function addSpecRecAction(cmd, rec) {
		const spec = gStorage.lists.speclist.list.find(x => x.fi.toLowerCase() === cmd);

		if (spec && (spec.t_type === TT_SPEC || spec.t_type === TT_SUBSPEC)) {
			console.log('spec', spec.fi);
			specChange(null, spec);

			if (gStorage.add.from_voice) {
				setTimeout(() => {
					gStorage.add.setStep(FIRST_OBS_STEP);
				}, 500);
			}
		} else {
			console.error('Species', cmd, 'not found!');
		}
	}

	useImperativeHandle(ref, () => ({
		addSpecRecAction
	}));

	if (gStorage.add.currentStep !== STEP_SPEC)
		return null;

/*
	let s_list = JSON.parse(JSON.stringify(gStorage.lists.speclist.list.filter(x => (x.t_type === TT_SPEC || x.t_type === TT_SUBSPEC) && x.visible === 1)));

	for (let i = 0; i < s_list.length; i++) {
		if (s_list[i].t_type === TT_SPEC) {
			s_list[i].subspecies = [];
			s_list[i].disp_name = addSpecGetSpecName(s_list[i]) + ', ' + s_list[i].abbr;
		}
	}

	for (let i = s_list.length - 1; i >= 0; i--) {
		if (s_list[i].t_type === TT_SUBSPEC) {
			let parent = s_list.find(x => x.id === s_list[i].p_id);
			if (!parent) {
				console.error('No parent for', s_list[i].id, s_list[i].p_id, s_list[i].t_type, s_list[i].sci);
				continue;
			}

			const ss = JSON.parse(JSON.stringify(s_list[i]));

			const ssa = ss.sci.split(' ' );
			let ss_name = '  ss. ';

			if (ssa.length) {
				ss_name += ssa[ssa.length - 1];
			} else {
				ss_name += '?';
			}

			ss.disp_name = ss_name;
			// console.log(i, 'push', s_list[i].sci, 'to', parent.sci);

			parent.subspecies.push(ss);

			s_list.splice(i, 1);
		}
	};


	for (let i = s_list.length - 1; i >= 0; i--) {
		if (s_list[i].t_type === TT_SPEC) {
			// s_list[i].subspecies = 
			s_list[i].subspecies.sort(sortIndentTaxons);
		}
	}
console.error('Sorting species!');
	const s_list2 = s_list.filter(x => x.t_type === TT_SPEC).sort(sortIndentTaxons);

	const spec_list = [];

	s_list2.forEach((le) => {
		spec_list.push({id: le.id, disp_name: le.disp_name});

		le.subspecies.forEach((sle) => {
			spec_list.push({id: sle.id, disp_name: sle.disp_name});
		})
	})

	// console.log('s_list2', s_list2);
	console.log('s_list2.length', s_list2.length);
	for (let i = 0; i < s_list2.length; i++) {
		if (s_list2[i].fi === 'Isolepinkäinen') {
			console.log('Isolepinkäinen', s_list2[i]);
		}
	};
	
	// console.log('s_list', s_list);
*/

// 	console.log('AddSpec', gStorage.add.obs.lat_tgt, gStorage.add.obs.long_tgt);

	return (
		<div>
			<Grid container direction="row" justifyContent="center" alignItems="center" spacing={0}>
				<Grid size={{xs: 12}} align={'center'}>
					<Autocomplete
						options={gStorage.lists.speclist.list.filter(x => (x.t_type === TT_SPEC || x.t_type === TT_SUBSPEC) && x.visible === 1 && x.abbr.length).sort(sortTaxons)}
						getOptionLabel={option => addSpecGetSpecName(option) + ', ' + option.abbr}
						value={gStorage.add.spec}
						onChange={specChange}
						autoSelect
						style={{width: 300, margin: 8}}
						renderInput={params => (
							<TextField {...params} label={t('add.species')} variant="outlined" size="small" fullWidth />
						)} />
				</Grid>

				<Grid size={{xs: 12}} align={'center'}>
					<FormControlLabel
						label={t('add.twitched')}
						labelPlacement="start"
						checked={!!gStorage.add.obs.twitched}
						onChange={twitchChange}
						control={<Checkbox color="primary" />}
						style={{margin: 8}}
					/>

					<FormControlLabel
						label={t('add.eco')}
						labelPlacement="start"
						checked={!!gStorage.add.obs.eco}
						onChange={ecoChange}
						control={<Checkbox color="primary" />}
						style={{margin: 8}}
					/>
				</Grid>
				<Grid size={{xs: 12}} align={'center'}>
					<FormControl variant="outlined" size="small" align='left' 
					    disabled={!gStorage.add.spec || gStorage.add.spec.fin_breeder === 0 || !gStorage.add.obs.lat_tgt || !gStorage.add.obs.long_tgt || !(gStorage.add.country.id === COUNTRY_ID_FI)}>
						<InputLabel>{t('add.fin_br_code')}</InputLabel>
						<Select
							value={gStorage.add.obs.fin_br_code}
							onChange={finBrCodeChanged}
							style={{width: 300, margin: 8}}>
								{finBrCodeList()}
						</Select>
					</FormControl>
					{gStorage.add.obs.fin_br_code ? 
						<div style={{width: 300, margin: 8, marginTop: 0, marginBottom: 16, padding:8}}>
						{t(brCodeList.find(brc => brc.id === gStorage.add.obs.fin_br_code).desc)}
						</div> : null
					}
				</Grid>		
				<Grid size={{xs: 12}} align={'center'}>
					<FormControl variant="outlined" size="small" align='left'>
						<InputLabel>{t('add.uncertainty')}</InputLabel>
						<Select
							value={gStorage.add.obs.uncertainty}
							onChange={uncertaintyChanged}
							style={{width: 300, margin: 8}}>
								{uncertaintyList()}
						</Select>
					</FormControl>
				</Grid>		
				<Grid size={{xs: 12}} align={'center'}>
					<TextField 
						label={t('add.additional_info')}
						variant="outlined"
						value={gStorage.add.obs.memo}
						onChange={memoChange}
						multiline rows="4" 
						size="small" 
						style={{width: 300, margin: 8}} 
					/>
				</Grid>
			</Grid>
		</div>
	);

}));

export default AddSpec;
